let draftPersistenceBlocked = false;

export function setDraftPersistenceBlocked(blocked: boolean): void {
  draftPersistenceBlocked = blocked;
}

export function isDraftPersistenceBlocked(): boolean {
  return draftPersistenceBlocked;
}
